import { api } from "../api/api";
import * as endpoints from "../data/links/endpoints";

export async function deleteComment({ signal, commentId }) {
  return api
    .get(endpoints.DELETE_COMMENT + commentId, { signal })
    .then((res) => res.data)
    .catch((error) => error.response);
}
